import { ApiServiceWithSettings, Audience, Authentication } from './common'
import { Pagination } from '@one/types'
import Page = Pagination.Page
import { AxiosPromise } from 'axios'

export class LongTasksBackoffice {
  constructor(private service: ApiServiceWithSettings) {
    this.service = service
  }
  getLongTasks(page: Page) {
    return this.service.get('/long-tasks/', {
      params: {
        ...page
      },
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }
  getLongTaskById(id: string) {
    return this.service.get(`/long-tasks/${id}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  uploadAttachment(
    uploadUrl: string,
    formData: any,
    fileType: string
  ): AxiosPromise<void> {
    return this.service.put(uploadUrl, formData, {
      rawUrl: true,
      injectToken: false,
      injectTenant: false,
      headers: {
        'Content-Type': fileType
      }
    })
  }

  finishUpload(url: string): AxiosPromise<void> {
    return this.service.post(url, null, {
      rawUrl: true,
      injectToken: false,
      injectTenant: false
    })
  }
}
